import { render } from "./BlocksTable.vue?vue&type=template&id=afa3e83a"
import script from "./BlocksTable.vue?vue&type=script&lang=js"
export * from "./BlocksTable.vue?vue&type=script&lang=js"

import "./BlocksTable.vue?vue&type=style&index=0&id=afa3e83a&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__